import { z as zod } from "zod";
import { Enum_Componentpricingpricetag_Unit } from "@/app/lib/generated/graphql-types";
import { MediaRefSchema } from "@/app/features/shared/__to_be_integrated/types/forms/MediaRefSchema";
import { LinkSchema } from "@/app/features/shared/__to_be_integrated/types/forms/LinkSchema";
import { RelatedInfoSchema } from "@/app/features/shared/types/schema";

export const PricingIntroSchema = zod.object({
    id: zod.string(),
    title: zod.string().min(1, "Der Seitentitel darf nicht leer sein."),
    subtitle: zod.string().nullish(),
    image: MediaRefSchema,
});

export const PricingPriceSchema = zod.object({
    id: zod.string().optional(),
    title: zod.string().min(1, "Die Preisbezeichnung darf nicht leer sein."),
    description: zod.string().nullish(),
    price: zod.number().min(0, "Der Preis darf nicht negativ sein."),
    unit: zod.nativeEnum(Enum_Componentpricingpricetag_Unit),
});

export const PricingCategorySchema = zod.object({
    id: zod.string().optional(),
    title: zod.string().min(1, "Der Kategorietitel darf nicht leer sein."),
    image: MediaRefSchema,
    prices: zod.array(PricingPriceSchema).nullish(),
    links: zod.array(LinkSchema).nullish(),
});

export const SitePricingSchema = zod.object({
    intro: PricingIntroSchema,
    categories: zod.array(PricingCategorySchema),
    relatedInfos: zod.array(RelatedInfoSchema),
});
